module.exports = __webpack_public_path__ + "img/vertical_layout_4.24fd38f8.png";